import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import Utils from '../../utils';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { getText, TEXT_KEY } from '../../utils/localization';
import Screens from '../../screens';
import audio from '../../utils/audio';
import CdnPath from '../../utils/cdnPath';
import { GAME_TRIGGERS } from '../../constants/types';
var TOOLTIP_STATES = {
  REWARD: 'reward',
  GAME_UNLOCK: 'gameUnlock',
  EMPTY: ''
};
var TOOLTIP_ANIMATION_STATES = {
  IN: 'in',
  OUT: 'out'
};
var LevelUp = /*#__PURE__*/function (_Component) {
  function LevelUp(props) {
    var _this;
    _classCallCheck(this, LevelUp);
    _this = _callSuper(this, LevelUp, [props]);
    _this.checkFontSizeBasedOnLength = function (text) {
      var textLen = text.length;
      if (textLen < 20) {
        return {
          nameFontSize: _this.props.RFValue(14),
          boxWidth: _this.props.RFValue(240),
          left: _this.props.RFValue(32)
        };
      } else if (textLen < 25) {
        return {
          nameFontSize: _this.props.RFValue(11),
          boxWidth: _this.props.RFValue(290),
          left: _this.props.RFValue(6)
        };
      } else {
        return {
          nameFontSize: _this.props.RFValue(8),
          boxWidth: _this.props.RFValue(270),
          left: _this.props.RFValue(18)
        };
      }
    };
    _this.checkLeftPositionBasedOnLengthInverted = function (text) {
      var textLen = text.length;
      if (textLen < 20) {
        return {
          left: _this.props.RFValue(390)
        };
      } else if (textLen < 25) {
        return {
          left: _this.props.RFValue(370)
        };
      } else {
        return {
          left: _this.props.RFValue(350)
        };
      }
    };
    _this.showGameUnlockTooltip = function () {
      var _this$props, _this$props2;
      var gameUnlock = _this.props.gameUnlock;
      var imageSource = {
        uri: "".concat(CdnPath.SLOT_ICON_MOBILE).concat(gameUnlock.GAME_ID, ".png")
      };
      var _tooltipDetails = {
        animationState: TOOLTIP_ANIMATION_STATES.IN,
        clickAbleTooltip: true,
        disableChildren: true,
        title: getText(TEXT_KEY.NEW_GAME),
        subTitle: !!gameUnlock && !!gameUnlock.GAME_NAME && gameUnlock.GAME_NAME.toUpperCase() || '-',
        source: imageSource,
        ibw: _this.props.ibw,
        gameImageStyle: _this.props.gameImageStyle,
        iconType: _this.props.iconType ? _this.props.iconType : {},
        containerStyle: {
          width: _this.checkFontSizeBasedOnLength(gameUnlock ? gameUnlock.GAME_NAME : '-').boxWidth,
          height: _this.props.RFValue(65),
          left: (_this$props = _this.props) !== null && _this$props !== void 0 && _this$props.isInverted ? _this.checkLeftPositionBasedOnLengthInverted(gameUnlock ? gameUnlock.GAME_NAME : '-').left : _this.checkFontSizeBasedOnLength(gameUnlock ? gameUnlock.GAME_NAME : '-').left
        },
        titleStyle: _this.props.titleStyle,
        subTitleStyle: {
          fontSize: _this.checkFontSizeBasedOnLength(gameUnlock ? gameUnlock.GAME_NAME : '-').nameFontSize,
          fontWeight: '700'
        },
        tipStyle: _objectSpread(_objectSpread({}, _this.props.tipStyle ? _this.props.tipStyle : {}), (_this$props2 = _this.props) !== null && _this$props2 !== void 0 && _this$props2.isInverted ? {
          right: '20%'
        } : {}),
        actionHandler: _this.launchGame
      };
      _this.props.tooltipDetails(_tooltipDetails);
      _this.props.shouldShowTooltip(true);
      setTimeout(function () {
        _this.props.tooltipDetails(_objectSpread(_objectSpread({}, _tooltipDetails), {}, {
          animationState: TOOLTIP_ANIMATION_STATES.OUT
        }));
      }, 6000);
    };
    _this.launchGame = function () {
      audio.onClick();
      QueryParamProxy.navigate(_this.props.navigation, Screens.Game, _defineProperty(_defineProperty({}, RouteParamConstants.PARAM_GAME_ID, _this.props.gameUnlock.GAME_ID), RouteParamConstants.PARAM_GAME_TRIGGER, GAME_TRIGGERS.LEVEL_UP));
      _this.props.setGameId(_this.props.gameUnlock.GAME_ID);
      _this.props.shouldShowTooltip(false);
    };
    _this.state = {
      tooltip: TOOLTIP_STATES.REWARD,
      animation: TOOLTIP_ANIMATION_STATES.IN
    };
    return _this;
  }
  _inherits(LevelUp, _Component);
  return _createClass(LevelUp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var nextTooltipState = this.props.gameUnlock ? TOOLTIP_STATES.GAME_UNLOCK : TOOLTIP_STATES.EMPTY;
      window.setTimeout(function () {
        _this2.setState({
          animation: TOOLTIP_ANIMATION_STATES.OUT
        }, function () {
          window.setTimeout(function () {
            _this2.setState({
              tooltip: nextTooltipState,
              animation: TOOLTIP_ANIMATION_STATES.IN
            }, function () {
              if (nextTooltipState === TOOLTIP_STATES.GAME_UNLOCK) {
                if (_this2.props.gameUnlock && !Utils.isWebOrMobileWeb()) {
                  _this2.showGameUnlockTooltip();
                }
                audio.playSfx('lockOpen', true, 1);
                window.setTimeout(function () {
                  _this2.setState({
                    animation: TOOLTIP_ANIMATION_STATES.OUT
                  }, function () {
                    window.setTimeout(function () {
                      _this2.setState({
                        tooltip: TOOLTIP_STATES.EMPTY,
                        animation: TOOLTIP_ANIMATION_STATES.IN
                      });
                    }, 600);
                  });
                }, 6000);
              }
            });
          }, 600);
        });
      }, 3000);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        coins = _this$props3.coins,
        maxBet = _this$props3.maxBet,
        gameUnlock = _this$props3.gameUnlock;
      return this.props.render({
        coins: Utils.truncateFormat(coins),
        maxBet: Utils.truncateFormat(maxBet),
        tooltip: this.state.tooltip,
        animation: this.state.animation,
        gameUnlock: gameUnlock,
        launchGame: this.launchGame
      });
    }
  }]);
}(Component);
export { LevelUp as default };
LevelUp.TOOLTIP_STATES = TOOLTIP_STATES;
LevelUp.TOOLTIP_ANIMATION_STATES = TOOLTIP_ANIMATION_STATES;